import * as React from "react";
import type { SVGProps } from "react";
const AddCursorDuotoneIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path stroke="#000" strokeLinecap="round" strokeLinejoin="round" d="M6 12h12m-6-6v12" /></svg>;
export default AddCursorDuotoneIcon;